<header class="section-header"
        [class.section-header--center]="align() === 'center'"
        [class.section-header--left]="align() === 'left'"
        [class.section-header--has-back]="showBack()"
        [attr.data-testid]="testId()">
  @if (showBack()) {
    <p-button type="button"
              icon="pi pi-arrow-left"
              severity="secondary"
              [text]="true"
              styleClass="bqa-secondary-btn bqa-back-btn"
              (click)="back.emit()"
              ariaLabel="Go back"
              [attr.data-testid]="testId() + '-back'" />
  }

  <div class="section-header-titles">
    <p class="section-header-title">{{ title() }}</p>
    @if (subtitle()) {
      <p class="section-header-subtitle">{{ subtitle() }}</p>
    }
  </div>

  <div class="section-header-actions">
    <ng-content select="[headerActions]" />
  </div>
</header>
